/**
 * Homepage Counter Animation
 * Animates counter numbers ONLY on the homepage statistics section
 * Isolated to prevent conflicts with dashboard counters
 */

// Track if animation has already run for this page load
let homepageCountersObserver = null;

function initializeHomepageCounters() {
  // Only run on homepage - check for specific homepage identifier
  const homepageStatCards = document.querySelectorAll('.homepage-stat-card');
  if (homepageStatCards.length === 0) {
    return; // Not on homepage, exit early
  }

  const counters = document.querySelectorAll('.homepage-counter-animate');
  
  if (counters.length === 0) return;

  // Cleanup previous observer if exists
  if (homepageCountersObserver) {
    homepageCountersObserver.disconnect();
    homepageCountersObserver = null;
  }

  const observerOptions = {
    threshold: 0.5,
    rootMargin: '0px'
  };

  const observerCallback = (entries, observer) => {
  entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        animateHomepageCounter(counter);
        observer.unobserve(counter);
      }
    });
  };

  homepageCountersObserver = new IntersectionObserver(observerCallback, observerOptions);

  counters.forEach(counter => {
    applyHomepageResponsiveFontSizing(counter);
    homepageCountersObserver.observe(counter);
  });
}

function applyHomepageResponsiveFontSizing(counter) {
  const contentLength = counter.innerText.replace(/\s/g, '').length;
  
  // Remove existing size classes
  counter.classList.remove('long-value', 'very-long-value', 'extremely-long-value', 'super-long-value', 'ultra-long-value');
  
  if (contentLength > 8) counter.classList.add('long-value');
  if (contentLength > 10) counter.classList.add('very-long-value');
  if (contentLength > 12) counter.classList.add('extremely-long-value');
  if (contentLength > 14) counter.classList.add('super-long-value');
  if (contentLength > 16) counter.classList.add('ultra-long-value');
}

function animateHomepageCounter(counter) {
  const text = counter.innerText;
  const numericPart = text.replace(/[^0-9,.]/g, '');
  const target = parseFloat(numericPart.replace(/\./g, '').replace(',', '.')) || 0;
  const prefix = text.replace(numericPart, '');
  const duration = 2000;
  const startTime = performance.now();
  
  let animationFrame = null;

  function updateCounter(currentTime) {
    const elapsedTime = currentTime - startTime;
    
    if (elapsedTime < duration) {
      const progress = elapsedTime / duration;
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      const currentValue = easeProgress * target;

      const formattedValue = new Intl.NumberFormat('pt-PT', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }).format(currentValue);

      counter.innerText = `${prefix}${formattedValue}`;
      animationFrame = requestAnimationFrame(updateCounter);
    } else {
      const formattedValue = new Intl.NumberFormat('pt-PT', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }).format(target);

      counter.innerText = `${prefix}${formattedValue}`;
      animationFrame = null;
    }
  }

  // Cancel any existing animation
  if (animationFrame) {
    cancelAnimationFrame(animationFrame);
  }
  
  animationFrame = requestAnimationFrame(updateCounter);
}

// Cleanup function for Turbo navigation
function cleanupHomepageCounters() {
  if (homepageCountersObserver) {
    homepageCountersObserver.disconnect();
    homepageCountersObserver = null;
  }
}

// Initialize on Turbo load
document.addEventListener('turbo:load', initializeHomepageCounters);

// Cleanup before cache to prevent conflicts
document.addEventListener('turbo:before-cache', cleanupHomepageCounters);

// Cleanup on before render
document.addEventListener('turbo:before-render', cleanupHomepageCounters);

// Export for potential reuse
export { initializeHomepageCounters, animateHomepageCounter, cleanupHomepageCounters };
